<template>
  <!-- <div id="app">
    <div v-if="isLoading" class="loading-screen">
      <div class="loading-content">
        <div class="percentage animate__animated animate__pulse">
          <p>{{ realPercentage }}<span class="small">%</span></p>
        </div>
      </div>
    </div>
    
    <div v-show="!isLoading" class="main-content animate__animated animate__fadeIn">
      <router-view />
    </div>
  </div> -->

  <router-view />
</template>

<script>
export default {
  name: 'App',
  /* data() {
    return {
      isLoading: true,
      realPercentage: 0,
      loadingMessage: 'Inicializando aplicación...',
      loadedResources: 0,
      totalResources: 0,
      resourceCheckInterval: null,
      hasRouterViewRendered: false
    }
  },
  mounted() {
    this.startAdvancedResourceMonitoring();
    
    this.maxLoadingTimeout = setTimeout(() => {
      console.log('Timeout - forzando carga');
      this.finishLoading();
    }, 12000);
  },
  beforeUnmount() {
    clearTimeout(this.maxLoadingTimeout);
    clearInterval(this.resourceCheckInterval);
  },
  methods: {
    async startAdvancedResourceMonitoring() {
      await this.$nextTick();
      
      setTimeout(() => {
        this.hasRouterViewRendered = true;
        this.startContinuousResourceCheck();
      }, 100);
    },
    
    startContinuousResourceCheck() {
      let checkCount = 0;
      const maxChecks = 120; 
      
      this.resourceCheckInterval = setInterval(() => {
        checkCount++;
        this.scanAllResources();
  
        if (this.areAllResourcesFullyLoaded() || checkCount >= maxChecks) {
          clearInterval(this.resourceCheckInterval);
          this.finishLoading();
        }
      }, 100);
    },
    
    scanAllResources() {
      const allImages = this.getAllImagesInApp();
      const allStylesheets = this.getAllStylesheets();
      const allScripts = this.getAllScripts();
      

      const loadedImages = allImages.filter(img => img.complete).length;
      const loadedStylesheets = allStylesheets.filter(link => link.sheet).length;
      
      this.totalResources = allImages.length + allStylesheets.length + allScripts.length;
      this.loadedResources = loadedImages + loadedStylesheets + allScripts.length; 
      

      this.calculateRealPercentage(loadedImages, allImages.length);
    },
    
    getAllImagesInApp() {
      return Array.from(document.querySelectorAll('img'));
    },
    
    getAllStylesheets() {
      return Array.from(document.querySelectorAll('link[rel="stylesheet"]'));
    },
    
    getAllScripts() {
      return Array.from(document.scripts);
    },
    
    calculateRealPercentage(loadedImages, totalImages) {
      
      const imageProgress = totalImages > 0 ? 
        (loadedImages / totalImages) * 70 : 0;
      
      
      const baseProgress = 14;
      
      this.realPercentage = Math.min(Math.floor(imageProgress + baseProgress), 99);
      
      this.updateLoadingMessage(this.realPercentage, loadedImages, totalImages);
    },
    
    updateLoadingMessage(percent, loadedImages, totalImages) {
      if (percent < 20) {
        this.loadingMessage = 'Cargando componentes principales...';
      } else if (percent < 50) {
        this.loadingMessage = `Cargando interfaz gráfica...`;
      } else if (percent < 80) {
        this.loadingMessage = `Optimizando imágenes... (${loadedImages}/${totalImages})`;
      } else if (percent < 95) {
        this.loadingMessage = 'Preparando experiencia final...';
      } else {
        this.loadingMessage = '¡Casi listo!';
      }
    },
    
    areAllResourcesFullyLoaded() {
      const allImages = this.getAllImagesInApp();
      const allStylesheets = this.getAllStylesheets();
      
      const allImagesLoaded = allImages.every(img => img.complete);
      const allStylesLoaded = allStylesheets.every(link => link.sheet);
      
      
      return this.hasRouterViewRendered && allImagesLoaded && allStylesLoaded;
    },
    
    finishLoading() {
      this.realPercentage = 100;
      this.loadingMessage = '¡Bienvenida!';
      
      clearTimeout(this.maxLoadingTimeout);
      clearInterval(this.resourceCheckInterval);
      
      setTimeout(() => {
        this.isLoading = false;
      }, 800);
    }
  } */
}
</script>

<style scoped>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--back);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
  color: var(--white);
}

.percentage p .small {
  font-size: 5vh;
  padding-left: 1vh;
  font-family: var(--font-regular)!important;
  font-weight: 300;
  color: var(--white);
}

.percentage p{
  color: var(--main-color);
  font-family: var(--font-monospace);
  font-weight: 400;
  font-size: 10vh;
}

.main-content {
  animation-duration: 2s;
}

@media only screen and (orientation : portrait){

}
@media only screen and (orientation : landscape){

}
</style>